export enum BettingOptionsGroupsTag {
    DEFAULT = 'default',
}
